<template>
  <!-- 合同详情页面 -->
    <myhead @next="next">
    {{ $route.query.title || $route.meta.title
    }}
  </myhead>
    <div v-for="item,index in list" class="mb10 pad10" :key="index">
        <img :src="item" style="width:100%" :onerror="Imgerror" :alt="item">
    </div>
</template>

<script setup>
import {onMounted,ref} from 'vue';
import {useRoute} from 'vue-router';
import ajax from "@/utils/request.js";

const route = useRoute();
const list = ref([]);
const init = () => {
    const data = {'order_id':route.query.order_id}
    ajax.post("order/getcontractimgs", data)
        .then((res) => {
            console.log(res.data.contract_imgs);
            list.value = res.data.contract_imgs;
        });
};
onMounted(() => {
  init()
})
</script>

<style lang="scss" scoped>

</style>